/**
 * Copyright (c) Qwoach LLC 2026. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
import BaseObject from "@shared/BaseObject.js";
import {isTouchDevice} from "@/core/screenHelper";

const MULTI_SELECT_HINT_WINDOW_MS = 15000
const MULTI_SELECT_HINT_MIN_UNIQUE_NODES = 3
const MULTI_SELECT_HINT_DURATION_MS = 5000
const MULTI_SELECT_HINT_DISMISSED_STORAGE_KEY = "genogramMultiSelectHintDismissed"

export default class GenogramMultiSelectHintController extends BaseObject {

	constructor({isSelectionModeEnabled, notifyHint}) {
		super()
		this.isSelectionModeEnabled = isSelectionModeEnabled || (() => false)
		this.notifyHint = notifyHint || (async () => {})
		this.recentNodeMoves = []
		this.isDismissed = this.isPersistedDismissed()
	}

	async onNodeDragFree(nodeId) {
		if(!nodeId || this.isDismissed){
			return
		}
		if(this.isSelectionModeEnabled()){
			return
		}

		let now = Date.now()
		this.recentNodeMoves.push({nodeId, time: now})
		this.cleanupOldMoves(now)
		if(!this.shouldShowHint()){
			return
		}

		this.dismissForSession()
		this.recentNodeMoves = []
		await this.notifyHint({
			message: this.createHintMessage(),
			duration: MULTI_SELECT_HINT_DURATION_MS,
		})
	}

	dismissForSession() {
		this.isDismissed = true
		this.recentNodeMoves = []
	}

	dismissPermanently() {
		this.dismissForSession()
		this.persistDismissed()
	}

	persistDismissed() {
		try {
			localStorage.setItem(MULTI_SELECT_HINT_DISMISSED_STORAGE_KEY, "true")
		} catch (error) {
			console.warn("GenogramMultiSelectHintController.persistDismissed failed", error)
		}
	}

	isPersistedDismissed() {
		try {
			return localStorage.getItem(MULTI_SELECT_HINT_DISMISSED_STORAGE_KEY) === "true"
		} catch (error) {
			console.warn("GenogramMultiSelectHintController.isPersistedDismissed failed", error)
			return false
		}
	}

	cleanupOldMoves(now) {
		this.recentNodeMoves = this.recentNodeMoves.filter(item => now - item.time <= MULTI_SELECT_HINT_WINDOW_MS)
	}

	shouldShowHint() {
		let uniqueNodeIds = [...new Set(this.recentNodeMoves.map(item => item.nodeId))]
		return uniqueNodeIds.length >= MULTI_SELECT_HINT_MIN_UNIQUE_NODES
	}

	createHintMessage() {
		if(isTouchDevice()){
			return "Selecting several nodes? Click the rectangle icon in the top bar."
		}
		return "Selecting several nodes? Hold Shift or click the rectangle icon in the top bar."
	}
}
